import * as React from "react";
import { FaTimes } from "react-icons/fa";
import ReactPlayer from "react-player";
import { default as ReactModal } from "react-modal";
import { ModalWrapper } from "./Styled";

class Modal extends React.Component {
  render() {
    const { modalVideoUrl, modalIsOpen, close } = this.props;
    return (
      <ReactModal
        ariaHideApp={false}
        isOpen={modalIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={close}
        // style={customStyles}
        contentLabel="Video Modal"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 200
          },
          content: {
            height: "calc(70vw / 1.78)",
            width: "100%",
            maxWidth: "70vw",
            borderRadius: 10,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            overflow: "visible",
            background: "#000",
            border: 0,
            padding: 10
          }
        }}
      >
        <ModalWrapper>
          <button className="close" onClick={close}>
            <FaTimes />
          </button>
          <ReactPlayer width="100%" height="100%" url={modalVideoUrl} playing controls />
        </ModalWrapper>
      </ReactModal>
    );
  }
}

export default Modal;
